import { render, staticRenderFns } from "./OrderHeader.vue?vue&type=template&id=4e9b06b8&scoped=true"
import script from "./OrderHeader.vue?vue&type=script&lang=ts"
export * from "./OrderHeader.vue?vue&type=script&lang=ts"
import style0 from "./OrderHeader.vue?vue&type=style&index=0&id=4e9b06b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9b06b8",
  null
  
)

export default component.exports